import Column from '@app/components/layout/Column'
import { Event } from '@app/components/blocks/event/Event'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { ServiceProviderViewModel } from 'functions/app/service-provider/view'

export const Events = ({
  serviceProvider,
}: {
  serviceProvider?: ServiceProviderViewModel
}) => {
  const translations = useTranslations().app
  return (
    <Column>
      <Title.H4>{translations.serviceProviderPage.events}</Title.H4>
      {serviceProvider.events &&
        serviceProvider.events.map((event) => (
          <Event
            key={event.uuid}
            date={new Date(event.start).getDate()}
            month={new Date(event.start).toLocaleDateString('en-US', {
              month: 'long',
            })}
            category={event.category}
            title={event.title}
            description={event.description}
            time={new Date(event.start).toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
            })}
            location={event.location?.address || 'Unknown'}
            onClick={() => console.warn('Event clicked!')}
          />
        ))}
    </Column>
  )
}
